/**
 * pdp-ingredients.js
 * How It Works carousel — prev/next arrow navigation, section-scoped.
 * Uses CSS transform on the track for smooth sliding.
 * Progress is driven by setting the width of the inner divider fill div.
 */
(function () {
  'use strict';

  function initIngredientSlider(sectionId) {
    var track    = document.getElementById('pdp-ingredients-track-'    + sectionId);
    var viewport = document.getElementById('pdp-ingredients-viewport-' + sectionId);
    var btnPrev  = document.getElementById('pdp-ingredients-prev-'     + sectionId);
    var btnNext  = document.getElementById('pdp-ingredients-next-'     + sectionId);
    var fill     = document.getElementById('pdp-ingredients-fill-'     + sectionId);
    var nav      = track && track.closest('.pdp-ingredients__inner')
                     ? track.closest('.pdp-ingredients__inner').querySelector('.pdp-ingredients__nav')
                     : null;

    if (!track || !viewport || !btnPrev || !btnNext) return;

    var cards        = Array.from(track.children);
    var totalCards   = cards.length;
    var currentIndex = 0;

    function getCardStep() {
      if (totalCards === 0) return 0;
      var card  = cards[0];
      var style = window.getComputedStyle(track);
      var gap   = parseFloat(style.columnGap) || 32;
      return card.offsetWidth + gap;
    }

    function getVisibleCount() {
      if (!viewport) return 1;
      var step = getCardStep();
      return step > 0 ? Math.floor(viewport.offsetWidth / step) : 1;
    }

    // Detect whether the natural total width (cards at fixed 300px + gaps)
    // fits in the viewport. If yes, switch to fit-mode so cards stretch.
    function recomputeFitMode() {
      // Force fixed-mode briefly to measure natural width
      track.removeAttribute('data-fits');
      var naturalWidth = 0;
      cards.forEach(function (c, i) {
        naturalWidth += c.offsetWidth;
        if (i < cards.length - 1) {
          var gap = parseFloat(window.getComputedStyle(track).columnGap) || 32;
          naturalWidth += gap;
        }
      });
      var fits = naturalWidth <= viewport.clientWidth + 1;
      if (fits) track.setAttribute('data-fits', 'true');
    }

    function getMaxIndex() {
      if (track.getAttribute('data-fits') === 'true') return 0;
      return Math.max(0, totalCards - getVisibleCount());
    }

    function updateSlider() {
      recomputeFitMode();
      var maxIndex = getMaxIndex();

      if (currentIndex > maxIndex) currentIndex = maxIndex;

      var fits = track.getAttribute('data-fits') === 'true';
      if (fits) {
        track.style.transform = '';
        currentIndex = 0;
      } else {
        var step = getCardStep();
        track.style.transform = 'translateX(-' + (currentIndex * step) + 'px)';
      }

      // Hide the divider+arrows nav row entirely when no navigation is needed
      if (nav) nav.style.display = fits ? 'none' : '';

      btnPrev.disabled = currentIndex <= 0;
      btnNext.disabled = currentIndex >= maxIndex;

      if (fill) {
        var pct = maxIndex > 0 ? Math.round((currentIndex / maxIndex) * 100) : 100;
        fill.style.width = pct + '%';
      }
    }

    btnPrev.addEventListener('click', function () {
      if (currentIndex > 0) {
        currentIndex -= 1;
        updateSlider();
      }
    });

    btnNext.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) {
        currentIndex += 1;
        updateSlider();
      }
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateSlider, 150);
    });

    updateSlider();
  }

  // Init all instances on page load
  document.querySelectorAll('[id^="pdp-ingredients-track-"]').forEach(function (el) {
    var sectionId = el.id.replace('pdp-ingredients-track-', '');
    initIngredientSlider(sectionId);
  });

  // Shopify theme editor live re-init
  document.addEventListener('shopify:section:load', function (e) {
    var track = e.target.querySelector('[id^="pdp-ingredients-track-"]');
    if (track) {
      var sectionId = track.id.replace('pdp-ingredients-track-', '');
      initIngredientSlider(sectionId);
    }
  });
})();